import { render, staticRenderFns } from "./svg-polygon.vue?vue&type=template&id=03f84747"
import script from "./svg-polygon.vue?vue&type=script&lang=js"
export * from "./svg-polygon.vue?vue&type=script&lang=js"
import style0 from "./svg-polygon.vue?vue&type=style&index=0&id=03f84747&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports